const isMobile = () => window.innerWidth < 768
const isMobileHorizontal = () => window.innerWidth >= 568 && window.innerWidth < 768
const isTablet = () => window.innerWidth >= 768 && window.innerWidth <= 1024
const isDesktop = () => window.innerWidth > 1024 && window.innerWidth <= 1920
const isBigDesktop = () => window.innerWidth > 1920
export { isMobile, isMobileHorizontal, isTablet, isDesktop, isBigDesktop }
